<template>
    <div>
        <el-form :model="paramForm" ref="paramForm" label-width="100px" size='medium'>
            <el-form-item label="车场编号：">
                <el-input v-model="paramForm.ud_parameter1"></el-input>
            </el-form-item>
            <el-form-item label="APPID：">
                <el-input v-model="paramForm.ud_parameter2"></el-input>
            </el-form-item>
            <el-form-item label="秘钥Key：">
                <el-input v-model="paramForm.ud_parameter3"></el-input>
            </el-form-item>
            <el-form-item label="账号：">
                <el-input v-model="paramForm.ud_parameter4"></el-input>
            </el-form-item>
            <el-form-item label="密码：">
                <el-input v-model="paramForm.ud_parameter5"></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default{
    data:function(){
        return{
        }
    },
    props: {
        paramForm: Object,
    },
    created () {

    },
    methods:{
        validateForm () {
            let flag = true
            if (!this.paramForm.ud_parameter1) {
                this.$message.error('请输入秘钥')
                flag = false
            }
            return flag
        }
    }
}
</script>


<style></style>